import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Core from './funciones_extras';
import Alertify from 'alertifyjs';
import { guardarFormatoHoraLocal } from '../utils/timeFormat';

const ConfigComponent = () => {
  const [configs, setConfigs] = useState([]);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    ruta_logo: '',
    ruta_favicon: '',
    email: '',
    numero_empresa: '',
    dominio: '',
    api_whatapps: '',
    api_token_ws: '',
    api_gmail: '',
    api_token_google: '',
    api_instagram: '',
    token_instagram: '',
    // Nuevos campos
    nombre_clinica: '',
    direccion_clinica: '',
    telefono_clinica: '',
    rnc_clinica: '',
    email_clinica: '',
    tipo_numero_factura: 'comprobante',
    prefijo_factura: '',
    usar_google_calendar: false,
    google_calendar_id: '',
    recordatorio_minutos: 30,
    clave_secreta: '',
    mensaje_cumpleanos: '',
    formato_hora_citas: '12h',
  });

  const [logoPreview, setLogoPreview] = useState(null);
  const [faviconPreview, setFaviconPreview] = useState(null);
  const [editId, setEditId] = useState(null);
  const [soporteVisible, setSoporteVisible] = useState(() => {
    try {
      return localStorage.getItem('kadosh_support_hidden') !== '1';
    } catch (_) {
      return true;
    }
  });

  const toggleSoporteVisible = () => {
    try {
      if (soporteVisible) {
        localStorage.setItem('kadosh_support_hidden', '1');
        setSoporteVisible(false);
        Alertify.message('Botón de soporte oculto en toda la aplicación.');
      } else {
        localStorage.removeItem('kadosh_support_hidden');
        setSoporteVisible(true);
        Alertify.success('Botón de soporte visible de nuevo.');
      }
      window.dispatchEvent(new Event('kadosh-support-visibility'));
    } catch (_) {
      Alertify.error('No se pudo guardar la preferencia.');
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = () => {
    Axios.get(`${Core.url_base}/api/configs`)
      .then((res) => {
        setConfigs(res.data);
        if (res.data.length > 0) {
          handleEdit(res.data[0]); // Cargar la primera configuración por defecto
          guardarFormatoHoraLocal(res.data[0].formato_hora_citas);
        }
      })
      .catch((err) => {
        console.error(err);
        Alertify.error("Error al cargar configuraciones");
      });
  };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (files && files[0]) {
      setFormData({ ...formData, [name]: files[0] });

      if (name === 'ruta_logo') {
        setLogoPreview(URL.createObjectURL(files[0]));
      }
      if (name === 'ruta_favicon') {
        setFaviconPreview(URL.createObjectURL(files[0]));
      }
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    for (const key in formData) {
      if (formData[key] !== null && formData[key] !== undefined) {
        if (key === 'ruta_logo' || key === 'ruta_favicon') {
          if (formData[key] instanceof File) {
            data.append(key, formData[key]);
          }
        } else {
          data.append(key, formData[key]);
        }
      }
    }

    if (editId) {
      Axios.post(`${Core.url_base}/api/configs/${editId}`, data)
        .then(() => {
          guardarFormatoHoraLocal(formData.formato_hora_citas);
          window.dispatchEvent(new Event('kadosh-config-updated'));
          Alertify.success("Configuración actualizada correctamente");
          fetchConfigs();
        })
        .catch((err) => {
          console.error(err);
          const msg = (err.response && err.response.data && (err.response.data.message || err.response.data.error))
            || (err.message === 'Network Error' ? 'Sin conexión con el servidor. Verifique que el backend esté en marcha.' : null)
            || 'Error al actualizar la configuración';
          Alertify.error(msg);
        });
    } else {
      Axios.post(`${Core.url_base}/api/configs`, data)
        .then(() => {
          guardarFormatoHoraLocal(formData.formato_hora_citas);
          window.dispatchEvent(new Event('kadosh-config-updated'));
          Alertify.success("Configuración guardada correctamente");
          fetchConfigs();
          resetForm();
        })
        .catch((err) => {
          console.error(err);
          const msg = (err.response && err.response.data && (err.response.data.message || err.response.data.error))
            || (err.message === 'Network Error' ? 'Sin conexión con el servidor. Verifique que el backend esté en marcha.' : null)
            || 'Error al guardar la configuración';
          Alertify.error(msg);
        });
    }
  };

  const resetForm = () => {
    setFormData({
      nombre: '',
      descripcion: '',
      ruta_logo: '',
      ruta_favicon: '',
      email: '',
      numero_empresa: '',
      dominio: '',
      api_whatapps: '',
      api_token_ws: '',
      api_gmail: '',
      api_token_google: '',
      api_instagram: '',
      token_instagram: '',
      nombre_clinica: '',
      direccion_clinica: '',
      telefono_clinica: '',
      rnc_clinica: '',
      email_clinica: '',
      tipo_numero_factura: 'comprobante',
      prefijo_factura: '',
      usar_google_calendar: false,
      google_calendar_id: '',
      recordatorio_minutos: 30,
      clave_secreta: '',
      mensaje_cumpleanos: '',
      formato_hora_citas: '12h',
    });
    setLogoPreview(null);
    setFaviconPreview(null);
    setEditId(null);
  };

  const handleEdit = (config) => {
    setFormData({
      nombre: config.nombre || '',
      descripcion: config.descripcion || '',
      ruta_logo: '',
      ruta_favicon: '',
      email: config.email || '',
      numero_empresa: config.numero_empresa || '',
      dominio: config.dominio || '',
      api_whatapps: config.api_whatapps || '',
      api_token_ws: config.api_token_ws || '',
      api_gmail: config.api_gmail || '',
      api_token_google: config.api_token_google || '',
      api_instagram: config.api_instagram || '',
      token_instagram: config.token_instagram || '',
      nombre_clinica: config.nombre_clinica || '',
      direccion_clinica: config.direccion_clinica || '',
      telefono_clinica: config.telefono_clinica || '',
      rnc_clinica: config.rnc_clinica || '',
      email_clinica: config.email_clinica || '',
      tipo_numero_factura: config.tipo_numero_factura || 'comprobante',
      prefijo_factura: config.prefijo_factura || '',
      usar_google_calendar: config.usar_google_calendar || false,
      google_calendar_id: config.google_calendar_id || '',
      recordatorio_minutos: config.recordatorio_minutos || 30,
      clave_secreta: config.clave_secreta || '',
      mensaje_cumpleanos: config.mensaje_cumpleanos || '',
      formato_hora_citas: config.formato_hora_citas === '24h' ? '24h' : '12h',
    });

    setLogoPreview(config.ruta_logo);
    setFaviconPreview(config.ruta_favicon);
    setEditId(config.id);
    window.scrollTo(0, 0);
  };

  const handleDelete = (id) => {
    Alertify.confirm(
      'Eliminar Configuración',
      '¿Está seguro de que desea eliminar esta configuración?',
      () => {
        Axios.delete(`${Core.url_base}/api/configs/${id}`)
          .then(() => {
            Alertify.success("Configuración eliminada correctamente");
            fetchConfigs();
          })
          .catch((err) => {
            console.error(err);
            Alertify.error("Error al eliminar la configuración");
          });
      },
      () => {
        Alertify.message("Operación cancelada");
      }
    );
  };

  return (
    <div className="col-12 col-md-10 kadosh-form-page">
      <div className="listado-pacientes-hero">
        <div className="listado-pacientes-hero-info">
          <div className="listado-pacientes-hero-icon">
            <i className="fas fa-cog" />
          </div>
          <div>
            <h1 className="listado-pacientes-hero-title">Configuración del sistema</h1>
            <p className="listado-pacientes-hero-subtitle">
              Datos de la clínica, integraciones y preferencias del calendario
            </p>
          </div>
        </div>
      </div>

      <div className="kadosh-form-shell">
          <form onSubmit={handleSubmit}>
            {/* Información General */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-info-circle"></i> Información General</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Nombre de la Configuración</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Descripción</label>
                    <input
                      type="text"
                      className="form-control"
                      name="descripcion"
                      value={formData.descripcion}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Información de la Clínica */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-hospital"></i> Información de la Clínica</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Nombre de la Clínica</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombre_clinica"
                      value={formData.nombre_clinica}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Dirección</label>
                    <textarea
                      className="form-control"
                      name="direccion_clinica"
                      value={formData.direccion_clinica}
                      onChange={handleChange}
                      rows="2"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Teléfono</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefono_clinica"
                      value={formData.telefono_clinica}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">RNC</label>
                    <input
                      type="text"
                      className="form-control"
                      name="rnc_clinica"
                      value={formData.rnc_clinica}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Correo Electrónico de la Clínica</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email_clinica"
                      value={formData.email_clinica}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Logos */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-image"></i> Logos</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Logo de la Clínica</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      name="ruta_logo"
                      onChange={handleChange}
                    />
                    {logoPreview && (
                      <div className="mt-2">
                        <img
                          src={logoPreview}
                          alt="Logo preview"
                          style={{ maxWidth: '200px', height: 'auto', border: '1px solid #ccc', padding: '5px' }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Favicon</label>
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      name="ruta_favicon"
                      onChange={handleChange}
                    />
                    {faviconPreview && (
                      <div className="mt-2">
                        <img
                          src={faviconPreview}
                          alt="Favicon preview"
                          style={{ maxWidth: '50px', height: 'auto', border: '1px solid #ccc', padding: '5px' }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Configuración de Facturas */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-file-invoice"></i> Configuración de Facturas/Comprobantes</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Tipo de Numeración</label>
                    <select
                      className="form-control"
                      name="tipo_numero_factura"
                      value={formData.tipo_numero_factura}
                      onChange={handleChange}
                    >
                      <option value="comprobante">Comprobante</option>
                      <option value="factura">NO XX FACTURA</option>
                    </select>
                    <small className="form-text text-muted">
                      Seleccione cómo desea que aparezca el número en los comprobantes
                    </small>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Prefijo (Ej: "NO 22" o "COMP")</label>
                    <input
                      type="text"
                      className="form-control"
                      name="prefijo_factura"
                      value={formData.prefijo_factura}
                      onChange={handleChange}
                      placeholder="Ej: NO 22"
                    />
                    <small className="form-text text-muted">
                      Si elige "NO XX FACTURA", ingrese el número (ej: "NO 22")
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Clave Secreta para Eliminaciones */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-key"></i> Clave Secreta para Eliminaciones</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Clave Secreta</label>
                    <input
                      type="password"
                      className="form-control"
                      name="clave_secreta"
                      value={formData.clave_secreta}
                      onChange={handleChange}
                      placeholder="Ingrese la clave secreta para eliminar perfiles, facturas o recibos"
                    />
                    <small className="form-text text-muted">
                      Esta clave será requerida para eliminar perfiles de pacientes, facturas o recibos
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Mensaje de cumpleaños */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-birthday-cake"></i> Mensaje de cumpleaños</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Mensaje para pacientes (WhatsApp y tarjeta)</label>
                    <textarea
                      className="form-control"
                      name="mensaje_cumpleanos"
                      value={formData.mensaje_cumpleanos}
                      onChange={handleChange}
                      rows={3}
                      placeholder="Ej: 🎉 ¡Hola {nombre}! 🎂 El equipo de {nombreClinica} te desea un feliz cumpleaños 🎈."
                    />
                    <small className="form-text text-muted">
                      Use <code>{'{nombre}'}</code> para el nombre del paciente y <code>{'{nombreClinica}'}</code> para el nombre de la clínica. Si lo deja vacío se usará el mensaje por defecto.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Calendar Integration */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-calendar-alt"></i> Calendario de citas</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Formato de hora en el calendario</label>
                    <select
                      className="form-control"
                      name="formato_hora_citas"
                      value={formData.formato_hora_citas}
                      onChange={handleChange}
                    >
                      <option value="12h">12 horas (1:00 PM – 11:59 PM)</option>
                      <option value="24h">24 horas / militar (13:00 – 23:59)</option>
                    </select>
                    <small className="form-text text-muted">
                      Aplica a la columna de horas al agendar citas en la vista semanal y diaria.
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Calendar Integration */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fab fa-google"></i> Integración con Google Calendar</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="usar_google_calendar"
                        checked={formData.usar_google_calendar}
                        onChange={handleChange}
                        id="usar_google_calendar"
                      />
                      <label className="form-check-label" htmlFor="usar_google_calendar">
                        Activar integración con Google Calendar
                      </label>
                    </div>
                    <small className="form-text text-muted">
                      Al activar, las citas se sincronizarán automáticamente con Google Calendar y se enviarán recordatorios por correo
                    </small>
                  </div>
                  {formData.usar_google_calendar && (
                    <>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Token de Google API</label>
                        <input
                          type="text"
                          className="form-control"
                          name="api_token_google"
                          value={formData.api_token_google}
                          onChange={handleChange}
                          placeholder="Token de acceso de Google"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">ID del Calendario de Google</label>
                        <input
                          type="text"
                          className="form-control"
                          name="google_calendar_id"
                          value={formData.google_calendar_id}
                          onChange={handleChange}
                          placeholder="ID del calendario (ej: primary)"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Recordatorio (minutos antes)</label>
                        <input
                          type="number"
                          className="form-control"
                          name="recordatorio_minutos"
                          value={formData.recordatorio_minutos}
                          onChange={handleChange}
                          min="0"
                        />
                        <small className="form-text text-muted">
                          Minutos antes de la cita para enviar el recordatorio
                        </small>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* APIs y Tokens */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-key"></i> APIs y Tokens</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email General</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Número de Empresa</label>
                    <input
                      type="text"
                      className="form-control"
                      name="numero_empresa"
                      value={formData.numero_empresa}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Dominio</label>
                    <input
                      type="text"
                      className="form-control"
                      name="dominio"
                      value={formData.dominio}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0"><i className="fas fa-headset"></i> Soporte en pantalla</h5>
              </div>
              <div className="card-body" style={{ padding: '20px' }}>
                <p className="text-muted mb-3" style={{ fontSize: '14px' }}>
                  Puede ocultar el botón flotante de soporte para todos los usuarios de este navegador.
                  También puede cerrarlo con la × junto al botón Soporte.
                </p>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="mostrar_boton_soporte"
                    checked={soporteVisible}
                    onChange={toggleSoporteVisible}
                    style={{ width: '3em', height: '1.5em', cursor: 'pointer' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="mostrar_boton_soporte" style={{ fontWeight: 600 }}>
                    Mostrar botón de soporte
                  </label>
                </div>
              </div>
            </div>

            <div className="kadosh-form-actions">
              <button type="submit" className="kadosh-btn kadosh-btn--primary">
                <i className="fas fa-save" /> {editId ? 'Actualizar' : 'Guardar'} configuración
              </button>
              {editId && (
                <button type="button" onClick={resetForm} className="kadosh-btn kadosh-btn--ghost">
                  <i className="fas fa-times" /> Cancelar
                </button>
              )}
            </div>
          </form>
      </div>

      {configs.length > 0 && (
        <div className="kadosh-form-shell kadosh-form-shell--table">
          <div className="card-header bg-info text-white" style={{ borderRadius: 0 }}>
            <h5 className="mb-0"><i className="fas fa-list" /> Configuraciones registradas</h5>
          </div>
          <div className="kadosh-table-wrap">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Clínica</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Tipo Factura</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {configs.map((cfg) => (
                    <tr key={cfg.id}>
                      <td>{cfg.nombre}</td>
                      <td>{cfg.nombre_clinica || '-'}</td>
                      <td>{cfg.email_clinica || cfg.email || '-'}</td>
                      <td>{cfg.telefono_clinica || cfg.numero_empresa || '-'}</td>
                      <td>
                        <span className={`badge ${cfg.tipo_numero_factura === 'factura' ? 'badge-warning' : 'badge-info'}`}>
                          {cfg.tipo_numero_factura === 'factura' ? 'NO XX FACTURA' : 'Comprobante'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button className="btn btn-sm btn-warning" onClick={() => handleEdit(cfg)}>
                            <i className="fas fa-edit"></i> Editar
                          </button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(cfg.id)}>
                            <i className="fas fa-trash"></i> Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigComponent;
